export enum DeviceIdentifierTypeEnum {
  IMEI = 'imei',
  ORDER_ID = 'orderId',
  RETURN_CASE_ID = 'returnCaseId',
}

export enum PublicRequestReturnLabelStateEnum {
  FORM = 'form',
  SUCCESS = 'success',
}

export enum PublicRequestReturnLabelTokenFlowStateEnum {
  CHECKING = 'checking',
  FALLBACK_MANUAL = 'fallback_manual',
  VALID_MANUAL = 'valid_manual',
  VALID_PREFILLED = 'valid_prefilled',
}

export interface DeviceIdentifier {
  identifierType: DeviceIdentifierTypeEnum
  value: string
}

export interface PublicRequestReturnLabelFormValues {
  devices: DeviceIdentifier[]
  contactName: string
  contactEmail: string
  companyName: string
  senderName: string
  street: string
  streetNumber: string
  zipcode: string
  city: string
  country: { label: string; value: string } | null
}

export interface DeviceIdentifierBlockProps {
  index: number
  showRemove: boolean
  onRemove: () => void
}

export interface PublicRequestReturnLabelFormProps {
  hasSubmitError: boolean
  isSubmitting: boolean
  onSubmit: (data: PublicRequestReturnLabelFormValues) => void
  showCustomerSupportCard: boolean
  showDeviceSection?: boolean
  showTokenModeBanner?: boolean
  showUsePrefilledButton?: boolean
  onUseManualDevices?: () => void
  onUsePrefilledDevices?: () => void
}

export interface PublicRequestReturnLabelSuccessProps {
  hasDangerousGoods: boolean
  requestToken: string
  trackingReference: string
}

export enum UserIdentifierTypeEnum {
  IMEI_SN = 'IMEI_SN',
  ORDER_ID = 'ORDER_ID',
  RETURN_CASE_ID = 'RETURN_CASE_ID',
}

export interface SubmitReturnLabelDevice {
  user_identifier: string
  user_identifier_type: UserIdentifierTypeEnum
}

export interface SubmitReturnLabelSenderAddress {
  full_name: string
  street_address: string
  street_number: string
  postal_code: string
  city: string
  country_code: string
}

export interface SubmitReturnLabelPayload {
  full_name: string
  email_address: string
  company_name: string
  sender_address: SubmitReturnLabelSenderAddress
  devices: SubmitReturnLabelDevice[]
  token: string
}

export type CheckReturnLabelTokenResult =
  | { kind: 'invalid' }
  | { kind: 'regenerated'; newToken: string }
  | { kind: 'valid_prefilled' }
  | { kind: 'valid_no_identifier' }
